import styled from 'styled-components';


export const HomeWrapper = styled.div(
    props => `
        width:100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: #ffffff;
        @media only screen and (min-width:320px) and (max-width: 767px){
            min-height:100vh;
        }

        @media only screen and (min-width:768px) and (max-width: 1024px){
            min-height:100vh;
        }
    `,
)

export const PageMainWrapper = styled.section(
    props => `
        width:100%;
        display: flex;
        flex-direction: row;
        background-color: #dff0ff;

        @media only screen and (min-width:320px) and (max-width: 767px){
            flex-direction: column;
        }

        @media only screen and (min-width:768px) and (max-width: 1024px){
            flex-direction: column;
        }
    `,
)
